import "./receipt.css";

import { type ReactNode } from "react";
import { useHardcopyBorders } from "@/theme/useHardcopyBorders";
import ReceiptHeader from "./ReceiptHeader";
import ReceiptFooter from "./ReceiptFooter";

export type ReceiptPrintProps = {
  children: ReactNode;
  /** Defaults to `tenants.name` from `GET /tenant-branding/me` (exact value). */
  title?: ReactNode;
  /** Appended below trust name and registration from the tenant record. */
  subTitle?: ReactNode;
  showTenantTrust?: boolean;
  /** Replaces the default footer lines ("Voluntary Contribution." and the computer-generated note). */
  footerNotes?: readonly string[];
};

const ReceiptPrint = ({
  children,
  title,
  subTitle,
  showTenantTrust,
  footerNotes,
}: ReceiptPrintProps) => {
  const { solid5 } = useHardcopyBorders();
  return (
    <>
      <div className="main-div">
        <div style={{ border: solid5, boxSizing: "border-box" }}>
          <div className="u-row-container" style={{ padding: 0 }}>
            <ReceiptHeader title={title} subTitle={subTitle} showTenantTrust={showTenantTrust} />

            <div className="u-row" style={{ margin: "0 auto" }}>
              {children}
            </div>
            <ReceiptFooter notes={footerNotes} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ReceiptPrint;
